import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "feed" }
const _hoisted_2 = { class: "head-wrapper" }
const _hoisted_3 = { class: "title" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_PulseButton = _resolveComponent("PulseButton")
  const _component_Burger = _resolveComponent("Burger")
  const _component_FeedFilters = _resolveComponent("FeedFilters")
  const _component_Icon = _resolveComponent("Icon")
  const _component_Loader = _resolveComponent("Loader")
  const _component_PulseEmpty = _resolveComponent("PulseEmpty")
  const _component_PulseItem = _resolveComponent("PulseItem")
  const _component_CollapseGroup = _resolveComponent("CollapseGroup")
  const _component_PulseBottom = _resolveComponent("PulseBottom")
  const _component_ScrollBar = _resolveComponent("ScrollBar")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: _normalizeClass(["head center", {hide: !$data.show_filters}])
      }, [
        _createElementVNode("div", _hoisted_3, [
          _cache[3] || (_cache[3] = _createElementVNode("span", { class: "title-text" }, "Today's Brief", -1 /* HOISTED */)),
          _createVNode(_component_PulseButton, {
            class: "active-trackers",
            text: "Active trackers",
            count: $options.tracker_total,
            color: "var(--brand-700)",
            icon: "settings-02",
            "icon-size": "1.6rem",
            onClick: _cache[0] || (_cache[0] = $event => (_ctx.$emit('toggle-tab')))
          }, null, 8 /* PROPS */, ["count"]),
          _createVNode(_component_Burger, { class: "burger" })
        ]),
        _createVNode(_component_FeedFilters, {
          ref: "filters",
          modelValue: $data.filters,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (($data.filters) = $event)),
          class: "pulse-filters",
          loading: $options.loading,
          "categories-count": $options.categories_count,
          "semantic-search": $options.semantic_search,
          "all-count": $options.all_count,
          "has-filters": $options.has_filters,
          onClear: $options.clearAll
        }, null, 8 /* PROPS */, ["modelValue", "loading", "categories-count", "semantic-search", "all-count", "has-filters", "onClear"])
      ], 2 /* CLASS */),
      ($options.has_filters)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            class: "mobile-clear pointer",
            type: "button",
            onClick: _cache[2] || (_cache[2] = (...args) => ($options.clearAll && $options.clearAll(...args)))
          }, [
            _createVNode(_component_Icon, {
              icon: "x-close",
              size: "1.6rem",
              stroke: "var(--gray-600)",
              "stroke-width": "1"
            }),
            _cache[4] || (_cache[4] = _createTextVNode(" Clear filters "))
          ]))
        : _createCommentVNode("v-if", true)
    ]),
    _createVNode(_component_ScrollBar, {
      ref: "scroller",
      class: "scroller",
      fade: "",
      "observer-threshold": 1,
      "bar-x-offset": "-2rem",
      onWheel: $options.onWheel,
      onScroll: $options.onScroll
    }, {
      default: _withCtx(() => [
        ($options.loading && $options.empty)
          ? (_openBlock(), _createBlock(_component_Loader, {
              key: 0,
              huge: ""
            }, {
              default: _withCtx(() => _cache[5] || (_cache[5] = [
                _createTextVNode(" Loading pulse... ")
              ])),
              _: 1 /* STABLE */
            }))
          : ($options.empty)
            ? (_openBlock(), _createBlock(_component_PulseEmpty, {
                key: 1,
                filters: $options.has_filters,
                onClear: $options.clearAll
              }, null, 8 /* PROPS */, ["filters", "onClear"]))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                _createVNode(_component_CollapseGroup, {
                  name: "list",
                  class: "pulse-items",
                  items: $options.items,
                  duration: 300,
                  gap: "1rem"
                }, {
                  default: _withCtx(({item}) => [
                    (_openBlock(), _createBlock(_component_PulseItem, {
                      key: item.id,
                      class: "pulse-item center",
                      active: item.id === $props.chosenId,
                      item: item,
                      onClick: $event => ($options.openSignal(item.id))
                    }, null, 8 /* PROPS */, ["active", "item", "onClick"]))
                  ]),
                  _: 1 /* STABLE */
                }, 8 /* PROPS */, ["items"]),
                _createVNode(_component_PulseBottom, {
                  ref: "bottom",
                  class: "center",
                  atend: $options.feed_atend,
                  loading: $options.loading
                }, null, 8 /* PROPS */, ["atend", "loading"])
              ], 64 /* STABLE_FRAGMENT */))
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["onWheel", "onScroll"])
  ]))
}